// src/App.js
import React, { useState, useEffect } from 'react';
import { AuthProvider }       from './components/AuthContext';
import PublicLayout           from './components/PublicLayout';
import AdminLayout            from './components/AdminLayout';
import LoginForm              from './components/LoginForm';
import HomePage               from './pages/HomePage';
import AdminProductsPage      from './pages/AdminProductsPage';
import SalesPage              from './pages/SalesPage';
import InventoryPage          from './pages/InventoryPage';
import DashboardPage          from './pages/DashboardPage';
import StoresPage             from './pages/StoresPage';
import RestockPage            from './pages/RestockPage';
import AdminAcademiaPage      from './pages/AdminAcademiaPage';
import ClasesPruebaPage       from './pages/ClasesPruebaPage';
import CosteoPage             from './pages/CosteoPage';
import EventoPage             from './pages/EventoPage';
import AdminEventosPage       from './pages/AdminEventosPage';

const bs = { fontFamily: "'Montserrat', sans-serif" };
const ds = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M4 5a1 1 0 011-1h4a1 1 0 011 1v5a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm10 0a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zm10-3a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1h-4a1 1 0 01-1-1v-7z"/>
    </svg>
  )},
  { id: 'academia', label: 'Academia', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/>
    </svg>
  )},
  { id: 'clases_prueba', label: 'Solicitudes', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
    </svg>
  )},
  { id: 'products', label: 'Productos', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
    </svg>
  )},
  { id: 'sales', label: 'Ventas', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
    </svg>
  )},
  { id: 'inventory', label: 'Inventario', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
    </svg>
  )},
  { id: 'stores', label: 'Tiendas', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
    </svg>
  )},
  { id: 'restock', label: 'Reabastecimiento', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
    </svg>
  )},
  { id: 'costeo', label: 'Costeo', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z"/>
    </svg>
  )},
  { id: 'eventos', label: 'Eventos', icon: (
    <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M15 5v2m-6-2v2M3 9h18M5 5h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z"/>
    </svg>
  )},
];

const AppContent = () => {
  const [currentView,  setCurrentView]  = useState('public');
  const [adminSection, setAdminSection] = useState('dashboard');

  // FIX 5: Inicializar publicView leyendo la URL actual
  const [publicView, setPublicView] = useState(() => {
    return window.location.pathname === '/evento' ? 'evento' : 'home';
  });

  // FIX 5: Manejar navegación con pushState + botón atrás del navegador
  const handleNavEvento = () => {
    setPublicView('evento');
    window.history.pushState({ view: 'evento' }, '', '/evento');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavHome = () => {
    setPublicView('home');
    window.history.pushState({ view: 'home' }, '', '/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // FIX 5: Soporte para botón "atrás" del navegador
  useEffect(() => {
    const onPopState = (e) => {
      const view = e.state?.view || (window.location.pathname === '/evento' ? 'evento' : 'home');
      setPublicView(view);
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  return (
    <>
      {currentView === 'public' ? (
        <PublicLayout onNavEvento={handleNavEvento} onNavHome={handleNavHome}>

          {publicView === 'home'   && <HomePage />}
          {publicView === 'evento' && <EventoPage />}

          <button onClick={() => setCurrentView('login')} title="Acceso Admin"
            style={{ position: 'fixed', bottom: '24px', right: '24px', zIndex: 90,
              width: '44px', height: '44px', borderRadius: '50%',
              background: 'rgba(6,13,20,0.65)', border: '1px solid rgba(255,255,255,0.08)',
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'rgba(255,255,255,0.45)', backdropFilter: 'blur(8px)', transition: 'all 0.2s',
            }}
            onMouseOver={e => { e.currentTarget.style.background = '#961914'; e.currentTarget.style.color = 'white'; }}
            onMouseOut={e => { e.currentTarget.style.background = 'rgba(6,13,20,0.65)'; e.currentTarget.style.color = 'rgba(255,255,255,0.45)'; }}>
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
          </button>
        </PublicLayout>

      ) : currentView === 'login' ? (
        <LoginForm onLoginSuccess={() => setCurrentView('admin')} onBack={() => setCurrentView('public')} />

      ) : (
        <AdminLayout>
          {/* Nav tabs */}
          <div style={{ background: 'white', borderBottom: '1px solid #f0eaea', overflowX: 'auto' }}>
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 24px',
              display: 'flex', alignItems: 'center', gap: '2px', minWidth: 'max-content' }}>
              {NAV_ITEMS.map(({ id, label, icon }) => {
                const active = adminSection === id;
                return (
                  <button key={id} onClick={() => setAdminSection(id)} style={{
                    ...bs, background: 'none', border: 'none', cursor: 'pointer',
                    padding: '13px 14px', display: 'flex', alignItems: 'center', gap: '6px',
                    fontSize: '11px', fontWeight: 600, letterSpacing: '0.12em',
                    textTransform: 'uppercase', whiteSpace: 'nowrap',
                    color: active ? '#961914' : '#aaa',
                    borderBottom: active ? '2px solid #961914' : '2px solid transparent',
                    transition: 'all 0.2s', marginBottom: '-1px',
                  }}
                  onMouseOver={e => { if (!active) e.currentTarget.style.color = '#060D14'; }}
                  onMouseOut={e => { if (!active) e.currentTarget.style.color = '#aaa'; }}>
                    <span style={{ color: active ? '#961914' : '#ccc', transition: 'color 0.2s' }}>
                      {icon}
                    </span>
                    {label}
                  </button>
                );
              })}
              <div style={{ flex: 1, minWidth: '12px' }} />
              <button onClick={() => setCurrentView('public')} style={{
                ...bs, background: 'none', border: 'none', cursor: 'pointer',
                padding: '13px 14px', display: 'flex', alignItems: 'center', gap: '6px',
                fontSize: '11px', fontWeight: 600, letterSpacing: '0.12em',
                textTransform: 'uppercase', color: '#bbb', transition: 'color 0.2s',
                borderBottom: '2px solid transparent', marginBottom: '-1px',
              }}
              onMouseOver={e => e.currentTarget.style.color = '#dc2626'}
              onMouseOut={e => e.currentTarget.style.color = '#bbb'}>
                <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                </svg>
                Salir
              </button>
            </div>
          </div>

          {/* Contenido */}
          <div>
            {adminSection === 'dashboard'     && <DashboardPage />}
            {adminSection === 'academia'      && <AdminAcademiaPage />}
            {adminSection === 'clases_prueba' && <ClasesPruebaPage />}
            {adminSection === 'products'      && <AdminProductsPage />}
            {adminSection === 'sales'         && <SalesPage />}
            {adminSection === 'inventory'     && <InventoryPage />}
            {adminSection === 'stores'        && <StoresPage />}
            {adminSection === 'restock'       && <RestockPage />}
            {adminSection === 'costeo'        && <CosteoPage />}
            {adminSection === 'eventos'       && <AdminEventosPage />}
          </div>
        </AdminLayout>
      )}
    </>
  );
};

const App = () => (
  <AuthProvider>
    <AppContent />
  </AuthProvider>
);

export default App;
